export const WEB_SCENE_ID = '81cb447e822f4ad890eb5b98cf3a23a9';
